import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_SINGLE_CLIENT_REPORT_DETAILS } from '../../types';
import { SINGLE_CLIENT_REPORT_ENTRIES_LOG_MESSAGES } from '../../constants/singleClientEntriesReportConstants';
import { getSingleClientReportDetailsPending, getSingleClientReportDetailsFulfilled, getSingleClientReportDetailsRejected } from '../../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../../actions';
import generateError from '../../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'report/getsingleclientreport',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(SINGLE_CLIENT_REPORT_ENTRIES_LOG_MESSAGES.NOT_FOUND)
    : getSingleClientReportDetailsFulfilled(response))],
  onError: [
    getSingleClientReportDetailsRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});
const meta = {
  api: 'ajaxApi',
};

const getSingleClientReportDetailsEpic$ = action$ => action$.pipe(
  ofType(GET_SINGLE_CLIENT_REPORT_DETAILS.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(getSingleClientReportDetailsPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default getSingleClientReportDetailsEpic$;


// WEBPACK FOOTER //
// ./src/features/reports/epics/single-client/getSingleClientReportDetailsEpic.js